<template>
  <div class="sidebar sidebar-left">
    <div :class="{ sticky: isSticky }">
        <h1 class="sidebar_title-main">Издания</h1>

        <div class="section_container">
          <router-link :to="{ path: '/books'}" class="body_text-plain last link" @click.native="$store.commit('SET_SECTION', '')">Все издания</router-link>
        </div>

        <div class="section_container" v-for="section in sections">
          <router-link :to="{ path: '/books'}" class="body_text-plain last link" @click.native="$store.commit('SET_SECTION', section)">{{ section }}</router-link>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isSticky: true
    };
  },
  computed: {
    sections() {
      let sectionList = this.$store.state.books.map(book => {
        return book.section;
      });
      return sectionList.filter(function(item, i, self) {
        return self.indexOf(item) == i;
      }).sort();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~styles/_vars.scss";

.sticky {
  position: fixed;
  width: $sidebar-width;
}

.section_container {
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// client/components/SidebarLeft.vue